import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import * as RVApi from "../../api/api";
import { RVLookupX } from "../../api/api";
import { ErrorContainer } from "@eres/forms";
import RVContext from "../../RVContext";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import FormRow from "@eres/forms-web/FormRow";
import TextInputField from "@eres/forms-web/TextInputField";
import { getAppServices } from "@10x/coreapp";
import PickerInput from "@eres/forms-web/PickerInput";
import { LocaleUtil, StringUtil } from "@eres/core";
import { IdExtractorFallback, lookupConverter } from "@my-dld/utils/LookupUtil";
import { RVLookUpTransformer } from "../../api/entities";
import { Lookup } from "@eres/ejari-api/Entity";
import { updateRVEnv, updateRVReason } from "../../RVUtils";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";

interface Props extends RoutedViewProps {
}

interface LookupState {
	Reasons?: Lookup[];
}

interface State extends LookupState {
	errorContainer: ErrorContainer;
	reason?: number;
	comments?: string;
	eid?: string;
	uid?: string;
	phone?: string;
}

class RVReason extends Component<Props, State> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
		};
		this.onProceed = this.onProceed.bind( this );
	}

	componentDidMount() {
		this.loadLookup( "RVReasons", "Reasons" );
		const store = getAppServices().storeService.getStore();
		let rValuation = store.getState().RValuation;
		if ( rValuation ) {
			this.setState( {
				reason: rValuation.reason ? rValuation.reason.Identity : undefined,
				comments: rValuation.comment,
				eid: rValuation.env.eidNumber,
				phone: rValuation.env.phoneNumber,
				uid: rValuation.env.uidNumber,
			} );
		}
	}

	loadLookup( key: string, stateKey: keyof LookupState, parm1: string = "", param2: string = "" ) {
		showLoading();
		RVApi.loadLookupsX( key, parm1, param2 )
		.then( RVApi.validateResponseX ).then( value => {
			hideLoading();
			let convert = value.map( RVLookUpTransformer );
			const update: Partial<State> = {};
			update[ stateKey ] = convert as Lookup[];
			this.setState( update as State );
		} ).catch( () => {
			hideLoading();
		} );
	}

	render() {
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-md-4 form-group",
			errorManager: defaultErrorManager,
		};
		const env = this.context.env;
		const { errorContainer } = this.state;
		return <React.Fragment>
			<div className="card mb-3">
				<div className="card-header">
					<span> { Strings.reason_for_valuation } </span>
				</div>
				<div className="card-body">
					<FormRow { ...filedProps }>
						<TextInputField
							id={ "phone" }
							disabled={ !env.editablePhone }
							label={ Strings.phone }
							maxLength={ 12 }
							error={ errorContainer.phone }
						/>
						<TextInputField
							id={ "eid" }
							disabled={ !env.editableEid }
							label={ Strings.emirates_id }
							maxLength={ 15 }
							error={ errorContainer.eid }
						/>
						<TextInputField
							id={ "uid" }
							label={ Strings.unified_reference_number }
							maxLength={ 15 }
							error={ errorContainer.uid }
						/>
						<PickerInput
							label={ Strings.reason_for_valuation }
							id={ "reason" }
							items={ this.state.Reasons }
							formatter={ item => LocaleUtil.getLocalValue( item ) }
							required={ true }
							error={ errorContainer.reason }
							toIdentifier={ IdExtractorFallback }
							valueConverter={ lookupConverter }/>

					</FormRow>
					<FormRow { ...filedProps }>
						<TextInputField
							id={ "comments" }
							label={ Strings.comments }
							error={ errorContainer.comments }
							containerClassName={ "col-md-12 form-group" }
							customInput={ <textarea rows={ 4 } maxLength={ 2000 }/> }
						/>
					</FormRow>
				</div>
			</div>
			<div className="enoc-add-buyer">
				<button
					className="btn btn_1 btn_style1 btn-sm" data-bs-target="#completedProjectsModal"
					onClick={ this.onProceed }
					data-bs-toggle="modal" type="button">
					{ Strings.proceed }
				</button>
			</div>
		</React.Fragment>;
	}

	onProceed = () => {
		if ( this.validateForm() ) {
			updateRVEnv( {
				...this.context.env,
				uidNumber: this.state.uid,
				phoneNumber: this.state.phone,
				eidNumber: this.state.eid,
			} );
			const m: Lookup = this.state.Reasons!.find( x => x.Id + "" === this.state.reason + "" )!;
			let reasonId: RVLookupX = {
				Identity: m.Id,
				NameAr: m.ar!,
				NameEn: m.en!,
			};
			updateRVReason( reasonId, this.state.comments! );
			navigateWithInParent( "rentalvaluation", "rvSummary" );
		}
	};

	validateForm = () => {
		let isValid = true;
		let errorContainer: ErrorContainer = {};
		isValid = checkNonEmpty( this.state, "phone", errorContainer ) && isValid;
		isValid = checkNonEmpty( this.state, "reason", errorContainer ) && isValid;
		isValid = checkNonEmpty( this.state, "comments", errorContainer ) && isValid;
		if ( StringUtil.isEmptyStringOrNull( this.state.eid ) && StringUtil.isEmptyStringOrNull( this.state.uid ) ) {
			isValid = false;
			errorContainer[ "eid" ] = Strings.required;
		}
		if ( isValid ) {
			if ( this.state.eid && ( this.state.eid.length !== 15 || !this.state.eid.startsWith( "784" ) ) ) {
				isValid = false;
				errorContainer[ "eid" ] = Strings.invalid_emirates_id_information;
			}
		}
		this.setState( {
			errorContainer: errorContainer,
		} );
		return isValid;
	};

}

export default RVReason;
